module.exports = __webpack_public_path__ + "img/level_three_hover.400c998b.png";